import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInitService } from '../../core/services/app-init.service';

@Component({
  selector: 'app-init',
  standalone: true,
  imports: [],
  templateUrl: './init.component.html',
  styleUrl: './init.component.scss'
})
export class InitComponent implements OnInit {

  constructor(
    private initService: AppInitService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initService.init().subscribe(() => {
      this.router.navigateByUrl('/landing');
    });
  }
}
